import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { acquireAccessToken } from './ApiService';
import { msalInstance } from 'index';

interface GridReportDataResponse { data: any[]; total_count: number; filter_values: any }
interface GridReportSchemaResponse { [key: string]: any }

export interface GridCombinedResponse extends GridReportDataResponse, GridReportSchemaResponse {}

const rawBaseQuery = fetchBaseQuery({ baseUrl: '/api/v1' });

const authBaseQuery: typeof rawBaseQuery = async (args, api, extraOptions) => {
  let modifiedArgs: any = typeof args === 'string' ? { url: args } : { ...args };
  try {
    const token = await acquireAccessToken(msalInstance);
    const headers = new Headers((modifiedArgs.headers as any) || undefined);
    headers.set('Accept', 'application/json');
    if (token) headers.set('Authorization', `Bearer ${token}`);
    modifiedArgs.headers = headers;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Grid reports token acquisition failed', e);
  }
  return rawBaseQuery(modifiedArgs, api, extraOptions);
};

export const gridReportsApiSlice = createApi({
  reducerPath: 'gridReportsApi',
  baseQuery: authBaseQuery,
  tagTypes: ['GridReport'],
  endpoints: builder => ({
    getGridReport: builder.query<GridCombinedResponse, { projectKey: string; reportId: string; query: string }>({
      query: ({ projectKey, reportId, query }) => `projects/${projectKey}/reports/${reportId}/data?${query}`,
      providesTags: (res, err, { reportId }) => [{ type: 'GridReport', id: reportId }],
    }),
    getGridReportSchema: builder.query<any, { projectKey: string; reportId: string }>({
      query: ({ projectKey, reportId }) => `projects/${projectKey}/reports/${reportId}/schema`,
      providesTags: (res, err, { reportId }) => [{ type: 'GridReport', id: reportId }],
    }),
  }),
});

export const { useGetGridReportQuery, useGetGridReportSchemaQuery } = gridReportsApiSlice;
